import { FC } from 'react';
import { MenuItem } from '@mui/material';

interface MenuPopoverItemProps {
    children: React.ReactNode;
    onClick?: () => void;
    disabled?: boolean;
}

const MenuPopoverItem: FC<MenuPopoverItemProps> = ({ children, onClick, disabled }) => (
    <MenuItem
        sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            columnGap: 1,
            px: 1,
            py: 0.75,
            ...(!onClick && {
                cursor: 'default',
                '&:hover': { backgroundColor: 'transparent' },
            }),
        }}
        onClick={onClick}
        disabled={disabled}
        disableRipple={!onClick}
    >
        {children}
    </MenuItem>
);

export default MenuPopoverItem;
